// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__22ihj","filled":"IconReviewStar_filled__3KrF7"};